import { useSelector } from 'react-redux';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { errorSteps } from '../views/StepConfigs';
import { getStepConfig } from '../views/getStepConfig';
import { Step } from '../views/Step';
import { useCurrentStep } from './useCurrentStep';
import { getIsActiveAndAssignedToVariantACQ125, getIsAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { VARIANT_A } from '../experiments/experimentDefaults';
export const useIsFramedCentredStep = () => {
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const isFramedCentredStep = stepConfig && stepConfig.isFramedCentredStep || false;
  const activeLoading = useSelector(getActiveLoading);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const isPostAccountCreationStep = postAccountCreation.includes(currentStep);
  const stepsToExclude = [...errorSteps, Step.ExistingUser, Step.ExistingAccounts];
  const isAssignedToVariant125 = useSelector(getIsActiveAndAssignedToVariantACQ125);
  const isAssignedToVariant126 = useSelector(state => getIsAssignedToVariant(state, ExperimentKeys.ACQ126, [VARIANT_A]));

  if (activeLoading || isPostAccountCreationStep || activeError || stepsToExclude.includes(currentStep)) {
    return {
      isFramedCentredStep: false
    };
  }

  if (isAssignedToVariant125 || isAssignedToVariant126) {
    return {
      isFramedCentredStep: true
    };
  }

  return {
    isFramedCentredStep
  };
};